import apiClient from "../api/client";

export const ClientService = {
  // Clients
  async getClients(params?: any) {
    const response = await apiClient.get("/clients/", { params });
    return response;
  },

  async getClient(id: string) {
    const response = await apiClient.get(`/clients/${id}/`);
    return response;
  },

  async createClient(data: any) {
    const response = await apiClient.post("/clients/", data);
    return response;
  },

  async updateClient(id: string, data: any) {
    const response = await apiClient.patch(`/clients/${id}/`, data);
    return response;
  },

  async getClientStats(id: string) {
    const response = await apiClient.get(`/clients/${id}/statistiques/`);
    return response;
  },

  // Contrats clients
  async getClientContrats(clientId: string) {
    const response = await apiClient.get(`/clients/${clientId}/contrats/`);
    return response;
  },

  async createClientContrat(clientId: string, data: any) {
    const response = await apiClient.post(
      `/clients/${clientId}/contrats/`,
      data
    );
    return response;
  },

  async updateClientContrat(clientId: string, contratId: string, data: any) {
    const response = await apiClient.put(
      `/clients/${clientId}/contrats/${contratId}/`,
      data
    );
    return response;
  },

  // Configuration client
  async getClientConfiguration(clientId: string) {
    const response = await apiClient.get(`/clients/${clientId}/configuration/`);
    return response;
  },

  async updateClientConfiguration(clientId: string, data: any) {
    const response = await apiClient.put(
      `/clients/${clientId}/configuration/`,
      data
    );
    return response;
  },

  // Fournisseurs
  async getClientFournisseurs() {
    // We use the relations endpoint from Fournisseur app/views.
    const response = await apiClient.get("/fournisseurs/relations/");
    return response;
  },

  async inviteFournisseur(data: { email: string; nom_entreprise: string }) {
    const response = await apiClient.post("/auth/invitations/", data);
    return response;
  },

  // Commissions
  async getAllCommissions() {
    const response = await apiClient.get("/clients/commissions/all/");
    return response;
  },

  async getClientCommissions(clientId: string) {
    const response = await apiClient.get(`/clients/${clientId}/commissions/`);
    return response;
  },

  async createCommission(clientId: string, data: any) {
    const response = await apiClient.post(
      `/clients/${clientId}/commissions/`,
      data
    );
    return response;
  },

  async updateCommission(commissionId: string, data: any) {
    const response = await apiClient.patch(
      `/clients/commissions/${commissionId}/`,
      data
    );
    return response;
  },

  async deleteCommission(commissionId: string) {
    const response = await apiClient.delete(
      `/clients/commissions/${commissionId}/`
    );
    return response;
  },
};
